module.exports = __webpack_public_path__ + "static/media/flags@2x.d429a577.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/libs/phone-number/flags@2x.png
 ** module id = 1301
 ** module chunks = 0
 **/